/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum CustomerBrokernetSignerRole {
    Makler = 'Makler',
    CustomerPerson = 'CustomerPerson'
  }

    export const CustomerBrokernetSignerRoleTranslocoMap: Record<CustomerBrokernetSignerRole, string> = {
    [CustomerBrokernetSignerRole.Makler]: 'customerBrokernetSignerRole.makler',
    [CustomerBrokernetSignerRole.CustomerPerson]: 'customerBrokernetSignerRole.customerPerson',
    };

    export const CustomerBrokernetSignerRoleOptions = [
  { value: CustomerBrokernetSignerRole.Makler, labelKey: 'customerBrokernetSignerRole.makler' },
  { value: CustomerBrokernetSignerRole.CustomerPerson, labelKey: 'customerBrokernetSignerRole.customerPerson' },
    ];

